/*var Woo_Checkout = {
    init: function () {
        Debug.log("WINDOW LOAD");
        $(document).on('updated_checkout', function () {
            Debug.log("Update checkout");
            $(".payment_method_stripe #payment_method_stripe").attr("data-order_button_text", "Pay by card");

        });
    }
}

$(window).load(function () {
    if ($(".woocommerce-checkout").length) {
        //Woo_Checkout.init();
    }
})
*/